import { render, staticRenderFns } from "./TheTableCoupons.vue?vue&type=template&id=77111610&scoped=true&"
import script from "./TheTableCoupons.vue?vue&type=script&lang=ts&"
export * from "./TheTableCoupons.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77111610",
  null
  
)

export default component.exports